export const isWeightMetric = (props) => {
    return props.weightUnit === 'g';
};
export const isWeightImperial = (props) => {
    return props.weightUnit === 'lb' || props.weightUnit === 'oz';
};
//# sourceMappingURL=types.js.map